// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"ff075e10","378":"8c1c0a2a","474":"88787192","820":"86d358f1"}[chunkId] + ".chunk.css";
};